import type { Registry } from './registry';

const LOGGED_IN_LAZY_MODULES = ['user-menu', 'user-notifications', 'active-rewards', 'welcome-popup'];

export function applyAuthStateLoggedIn(registry?: Registry): void {
  document.querySelectorAll<HTMLElement>('[data-auth-state="logged-in"]').forEach((el) => {
    el.removeAttribute('hidden');
  });
  document.querySelectorAll<HTMLElement>('[data-auth-state="logged-out"]').forEach((el) => {
    el.setAttribute('hidden', '');
  });
  if (!registry) return;
  for (const name of LOGGED_IN_LAZY_MODULES) {
    void registry.require(name).catch(() => undefined);
  }
}
